import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

type BillingResultVariant = 'success' | 'cancel';

const messages: Record<
  BillingResultVariant,
  { title: string; description: string; cta: string; icon: typeof CheckCircleIcon }
> = {
  success: {
    title: 'Thanks for upgrading!',
    description: 'Your payment was successful. We are refreshing your premium access now.',
    cta: 'Go to Billing',
    icon: CheckCircleIcon,
  },
  cancel: {
    title: 'Checkout canceled',
    description: 'No charges were made. You can restart checkout whenever you are ready.',
    cta: 'Try Again',
    icon: ErrorOutlineIcon,
  },
};

const BillingResult = ({ variant }: { variant: BillingResultVariant }) => {
  const navigate = useNavigate();
  const { title, description, cta, icon: Icon } = messages[variant];

  const handleClick = () => {
    navigate('/billing');
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 4,
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Icon
            color={variant === 'success' ? 'success' : 'warning'}
            sx={{ fontSize: 64 }}
          />
        </Box>
        <Typography variant="h4" sx={{ mb: 1, fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
        <Button variant="contained" size="large" onClick={handleClick}>
          {cta}
        </Button>
      </Paper>
    </Container>
  );
};

export const BillingSuccessPage = () => <BillingResult variant="success" />;
export const BillingCancelPage = () => <BillingResult variant="cancel" />;

export default BillingResult;



